export const REPORT_BI_TOKEN = 'token';
export const REPORT_BI_EMBEDED_URL = 'embedUrl';
